import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import "./Banner.css";
import {
  Container,
  BannerBody,
  BannerContainer,
  BannerDescription,
  Card,
  BannerHeading,
  StatsBar,
  StatItem,
  StatNumber,
  StatLabel,
  GlowEffect,
} from "./Banner.style";
import Button from "../Button/Button";
import solarbg from "../../assets/hero-solar.jpg";

export default function Banner(props) {
  const { description, title } = props;
  const navigate = useNavigate();
  return (
    <Container>
      <BannerContainer bg={solarbg} mobileBg={solarbg}>
        <GlowEffect />
        <BannerBody>
          <BannerHeading>{title}</BannerHeading>
          <BannerDescription>{description}</BannerDescription>

          <Button
            onClick={() => {
              navigate("/contact");
            }}
            label="GET FREE SOLAR QUOTE"
            format="outlined"
            size="large"
          />

          <StatsBar data-aos="fade-up" data-aos-delay="200">
            <StatItem>
              <StatNumber>500+</StatNumber>
              <StatLabel>Installations</StatLabel>
            </StatItem>
            <StatItem>
              <StatNumber>₦50M+</StatNumber>
              <StatLabel>Client Savings</StatLabel>
            </StatItem>
            <StatItem>
              <StatNumber>25</StatNumber>
              <StatLabel>Years Warranty</StatLabel>
            </StatItem>
          </StatsBar>
        </BannerBody>
      </BannerContainer>
      <div className="d-flex justify-content-end w-100">
        <Card data-aos="fade-right">
          <BannerDescription style={{ color: "#F5A623", fontWeight: "600" }}>
            Start saving up to 80% on energy bills
          </BannerDescription>
        </Card>
      </div>
    </Container>
  );
}

Banner.defaultProps = {
  title: "POWER YOUR FUTURE WITH SOLAR ENERGY",
  description:
    "Professional solar panel installation for homes and businesses. Cut your energy costs by up to 80% with clean, renewable power.",
};

Banner.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};
